import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1fc06862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active",
    id: "support-details-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#support-details-tab-pane",
    type: "button",
    role: "tab",
    "aria-controls": "support-details-tab-pane",
    "aria-selected": "true"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book" }),
    /*#__PURE__*/_createTextVNode(" Détails du support ")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
  id: "payment-method-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#payment-method-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "payment-method-tab-pane",
  "aria-selected": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-atm" }),
  /*#__PURE__*/_createTextVNode(" QCM ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
    id: "place-order-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#place-order-tab-pane",
    type: "button",
    role: "tab",
    "aria-controls": "place-order-tab-pane",
    "aria-selected": "false"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sterile-box" }),
    /*#__PURE__*/_createTextVNode(" Liste des inscrits en ligne ")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  role: "presentation"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100",
    id: "fourth-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#fourth-tab-pane",
    type: "button",
    role: "tab",
    "aria-controls": "fourth-tab-pane",
    "aria-selected": "false"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layers" }),
    /*#__PURE__*/_createTextVNode(" Quatrième onglet ")
  ])
], -1))
const _hoisted_10 = {
  class: "tab-content p-15 p-sm-20 p-md-25 p-lg-30",
  id: "myTabContent"
}
const _hoisted_11 = {
  class: "tab-pane fade show active",
  id: "support-details-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_12 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Retour", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Détails du support de cours", -1))
const _hoisted_16 = { class: "row mb-4" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "info-card p-3 border rounded bg-light" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }),
  /*#__PURE__*/_createTextVNode("Informations générales ")
], -1))
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Titre :")
], -1))
const _hoisted_22 = { class: "col-7" }
const _hoisted_23 = { class: "row mb-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Image:")
], -1))
const _hoisted_25 = { class: "col-7" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Description :")
], -1))
const _hoisted_29 = { class: "col-7" }
const _hoisted_30 = { class: "row mb-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Auteur :")
], -1))
const _hoisted_32 = { class: "col-7" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nombre d'heures :")
], -1))
const _hoisted_35 = { class: "col-7" }
const _hoisted_36 = { class: "row mb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nombre de modules :")
], -1))
const _hoisted_38 = { class: "col-7" }
const _hoisted_39 = { class: "badge bg-success" }
const _hoisted_40 = { class: "row mb-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Prérequis :")
], -1))
const _hoisted_42 = { class: "col-7" }
const _hoisted_43 = { class: "row mb-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Fichier principal :")
], -1))
const _hoisted_45 = { class: "col-7" }
const _hoisted_46 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_47 = { class: "file-name-display mb-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-2 text-danger" }, null, -1))
const _hoisted_49 = { class: "text-muted" }
const _hoisted_50 = { class: "d-flex gap-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1))
const _hoisted_52 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "info-card p-3 border rounded bg-light" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layers me-2" }),
  /*#__PURE__*/_createTextVNode("Filière / Niveau / Matière ")
], -1))
const _hoisted_56 = { class: "row mb-2" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Filière :")
], -1))
const _hoisted_58 = { class: "col-7" }
const _hoisted_59 = { class: "badge bg-info" }
const _hoisted_60 = { class: "row mb-2" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Niveau :")
], -1))
const _hoisted_62 = { class: "col-7" }
const _hoisted_63 = { class: "badge bg-warning" }
const _hoisted_64 = { class: "row mb-2" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Matière :")
], -1))
const _hoisted_66 = { class: "col-7" }
const _hoisted_67 = { class: "badge bg-primary" }
const _hoisted_68 = { class: "row mb-2" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de création :")
], -1))
const _hoisted_70 = { class: "col-7" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-black fw-bold mt-4" }, "Vidéos et textes du support")
], -1))
const _hoisted_73 = { class: "col text-end" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle lh-2 me-8 position-relative top-1" }, null, -1))
const _hoisted_75 = { class: "row mt-4" }
const _hoisted_76 = { class: "col-md-6 mb-3" }
const _hoisted_77 = { class: "text-primary mb-3 border-bottom pb-2" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-video me-2" }, null, -1))
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_81 = { class: "text-muted small" }
const _hoisted_82 = { class: "badge bg-secondary" }
const _hoisted_83 = { class: "badge bg-warning text-dark" }
const _hoisted_84 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Description :", -1))
const _hoisted_86 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "URL :", -1))
const _hoisted_88 = ["href"]
const _hoisted_89 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fichier :", -1))
const _hoisted_91 = { class: "text-muted ms-1" }
const _hoisted_92 = { class: "d-flex gap-2 mt-2" }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1))
const _hoisted_95 = {
  key: 3,
  class: "text-muted mt-1"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Aucun lien disponible", -1))
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-2" }, null, -1))
const _hoisted_100 = { class: "col-md-6 mb-3" }
const _hoisted_101 = { class: "text-primary mb-3 border-bottom pb-2" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-alt me-2" }, null, -1))
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_105 = { class: "text-muted small" }
const _hoisted_106 = { class: "badge bg-info text-dark" }
const _hoisted_107 = { class: "badge bg-info text-dark" }
const _hoisted_108 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fichier :", -1))
const _hoisted_110 = { class: "text-muted ms-1" }
const _hoisted_111 = { class: "d-flex gap-2 mt-2" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1))
const _hoisted_114 = {
  key: 1,
  class: "text-muted mt-1"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Aucun fichier disponible", -1))
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-2" }, null, -1))
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-md-12" }
const _hoisted_121 = { class: "text-primary mb-3 border-bottom pb-2" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }, null, -1))
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "cours-header bg-primary text-white p-2 rounded mb-3" }
const _hoisted_125 = { class: "mb-0" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }, null, -1))
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-md-3" }
const _hoisted_129 = { class: "info-item mb-2" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Code", -1))
const _hoisted_131 = { class: "col-md-3" }
const _hoisted_132 = { class: "info-item mb-2" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Titre", -1))
const _hoisted_134 = { class: "col-md-3" }
const _hoisted_135 = { class: "info-item mb-2" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Description", -1))
const _hoisted_137 = { class: "col-md-3" }
const _hoisted_138 = { class: "info-item mb-2" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Fichier du module", -1))
const _hoisted_140 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_141 = { class: "file-name-display mb-2" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-1 text-danger" }, null, -1))
const _hoisted_143 = { class: "text-muted" }
const _hoisted_144 = { class: "d-flex gap-2" }
const _hoisted_145 = ["onClick"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1))
const _hoisted_147 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_148 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-2" }, null, -1))
const _hoisted_150 = {
  class: "tab-pane fade",
  id: "payment-method-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_151 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_152 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-0 text-black fw-bold" }, "Questions du support", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-2" }, null, -1))
const _hoisted_155 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left me-2" }, null, -1))
const _hoisted_157 = {
  class: "tab-pane fade",
  id: "place-order-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_158 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_159 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_160 = { class: "d-flex align-items-center" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1))
const _hoisted_162 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_163 = { class: "table-responsive" }
const _hoisted_164 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Prénom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Sexe "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Téléphone 1 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date de naissance ")
  ])
], -1))
const _hoisted_166 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_167 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_168 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_169 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_170 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_171 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }, null, -1))
const _hoisted_173 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "fourth-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-15 mb-md-25 fw-bold text-black" }, "Quatrième onglet")
], -1))
const _hoisted_175 = { class: "modal-dialog modal-xl modal-dialog-top" }
const _hoisted_176 = { class: "modal-content" }
const _hoisted_177 = { class: "modal-header bg-primary text-white" }
const _hoisted_178 = { class: "modal-title" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-2" }, null, -1))
const _hoisted_180 = { class: "modal-body p-0 pdf-viewer-container" }
const _hoisted_181 = ["src"]
const _hoisted_182 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"80vh"}
}
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_184 = [
  _hoisted_183
]
const _hoisted_185 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ListeQuestion = _resolveComponent("ListeQuestion")!
  const _component_AddQuestionQCM = _resolveComponent("AddQuestionQCM")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _hoisted_4,
        (_ctx.checkPermission('ListQuestionFiltre'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        _hoisted_8,
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: "/liste-support",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _hoisted_14
              ]),
              _: 1
            }),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.supportCours?.titre || 'Aucun titre'), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("img", {
                      src: _ctx.getUrlApiForFilesSupport(_ctx.supportCours?.urlImage || 'Aucune image'),
                      alt: "Image",
                      width: "200",
                      height: "200"
                    }, null, 8, _hoisted_26)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.supportCours?.description || 'Aucune description'), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.supportCours?.auteur || 'Aucun Auteur'), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.supportCours?.nombreHeures || 0) + " h", 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.supportCours?.modules?.length || 0), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.supportCours?.prerequis || 'Aucun'), 1)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    (_ctx.supportCours?.fichier)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("small", _hoisted_49, _toDisplayString(_ctx.supportCours.fichier), 1)
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewSupportFile(_ctx.supportCours.id))),
                              class: "btn btn-sm btn-outline-primary"
                            }, [
                              _hoisted_51,
                              _createTextVNode("Voir ")
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_52, "Aucun fichier"))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.supportCours?.filiereNiveauMatiere?.filiere?.libelle || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.supportCours?.filiereNiveauMatiere?.niveau?.libelle || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.supportCours?.filiereNiveauMatiere?.matiere?.libelle || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.formatDate(_ctx.supportCours?.createdAt)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _createElementVNode("div", _hoisted_73, [
              _createVNode(_component_router_link, {
                to: { name: 'AddSupportCours', params: { id: _ctx.supportCours?.id } },
                class: "btn btn-primary mt-3 text-center"
              }, {
                default: _withCtx(() => [
                  _hoisted_74,
                  _createTextVNode(" Compléter vidéo et support ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("h5", _hoisted_77, [
                _hoisted_78,
                _createTextVNode("Vidéos (" + _toDisplayString(_ctx.videos.length) + ") ", 1)
              ]),
              (_ctx.videos.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: video.id,
                        class: "border rounded p-3 mb-3 bg-white shadow-sm"
                      }, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(video.libelle || 'Sans titre'), 1),
                            _createElementVNode("div", _hoisted_81, [
                              _createTextVNode(" Type source : "),
                              _createElementVNode("span", _hoisted_82, _toDisplayString(video.type || 'N/A'), 1)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_83, "Vidéo " + _toDisplayString(index + 1), 1)
                        ]),
                        (video.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_84, [
                              _hoisted_85,
                              _createTextVNode(" " + _toDisplayString(video.description), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (video.type === 'url' && video.lien)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              _hoisted_87,
                              _createElementVNode("a", {
                                href: video.lien,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "ms-1"
                              }, _toDisplayString(video.lien), 9, _hoisted_88)
                            ]))
                          : (video.type === 'fichier' && video.lien)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                _hoisted_90,
                                _createElementVNode("span", _hoisted_91, _toDisplayString(video.lien), 1),
                                _createElementVNode("div", _hoisted_92, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.viewMediaFile(video.id, video.libelle)),
                                    class: "btn btn-sm btn-outline-primary"
                                  }, [
                                    _hoisted_94,
                                    _createTextVNode("Voir ")
                                  ], 8, _hoisted_93)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_95, _hoisted_97))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _hoisted_99,
                    _createTextVNode("Aucune vidéo ajoutée pour ce support. ")
                  ]))
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("h5", _hoisted_101, [
                _hoisted_102,
                _createTextVNode("Textes (" + _toDisplayString(_ctx.textes.length) + ") ", 1)
              ]),
              (_ctx.textes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textes, (texte, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: texte.id,
                        class: "border rounded p-3 mb-3 bg-white shadow-sm"
                      }, [
                        _createElementVNode("div", _hoisted_104, [
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(texte.libelle || 'Sans titre'), 1),
                            _createElementVNode("div", _hoisted_105, [
                              _createTextVNode(" Type : "),
                              _createElementVNode("span", _hoisted_106, _toDisplayString(texte.type || 'N/A'), 1)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_107, "Texte " + _toDisplayString(index + 1), 1)
                        ]),
                        (texte.lien)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                              _hoisted_109,
                              _createElementVNode("span", _hoisted_110, _toDisplayString(texte.lien), 1),
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.viewMediaFile(texte.id, texte.libelle)),
                                  class: "btn btn-sm btn-outline-primary"
                                }, [
                                  _hoisted_113,
                                  _createTextVNode("Voir ")
                                ], 8, _hoisted_112)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_114, _hoisted_116))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_117, [
                    _hoisted_118,
                    _createTextVNode("Aucun texte ajouté pour ce support. ")
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("h5", _hoisted_121, [
                _hoisted_122,
                _createTextVNode("Liste des modules (" + _toDisplayString(_ctx.supportCours?.modules?.length || 0) + ") ", 1)
              ]),
              (_ctx.supportCours?.modules && _ctx.supportCours.modules.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportCours.modules, (module, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: module.id,
                        class: "cours-card border rounded p-3 mb-3 shadow-sm bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_124, [
                          _createElementVNode("h6", _hoisted_125, [
                            _hoisted_126,
                            _createTextVNode("Module " + _toDisplayString(index + 1) + " : " + _toDisplayString(module.titre), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          _createElementVNode("div", _hoisted_128, [
                            _createElementVNode("div", _hoisted_129, [
                              _hoisted_130,
                              _createElementVNode("strong", null, _toDisplayString(module.code || 'Sans code'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_131, [
                            _createElementVNode("div", _hoisted_132, [
                              _hoisted_133,
                              _createElementVNode("strong", null, _toDisplayString(module.titre || 'Aucun titre'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_134, [
                            _createElementVNode("div", _hoisted_135, [
                              _hoisted_136,
                              _createElementVNode("strong", null, _toDisplayString(module.description || 'Aucune description'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_137, [
                            _createElementVNode("div", _hoisted_138, [
                              _hoisted_139,
                              (module.fichier)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                    _createElementVNode("div", _hoisted_141, [
                                      _hoisted_142,
                                      _createElementVNode("small", _hoisted_143, _toDisplayString(module.fichier), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_144, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.viewModuleFile(module.id)),
                                        class: "btn btn-sm btn-outline-primary"
                                      }, [
                                        _hoisted_146,
                                        _createTextVNode("Voir ")
                                      ], 8, _hoisted_145)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_147, "Aucun fichier"))
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    _hoisted_149,
                    _createTextVNode("Aucun module trouvé pour ce support de cours. ")
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_150, [
          _withDirectives(_createElementVNode("div", _hoisted_151, [
            _createElementVNode("div", _hoisted_152, [
              _hoisted_153,
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddQuestionForm = true)),
                class: "btn btn-primary"
              }, [
                _hoisted_154,
                _createTextVNode(" Ajouter une question ")
              ])
            ]),
            _createElementVNode("div", _hoisted_155, [
              _createVNode(_component_ListeQuestion, {
                "support-id": _ctx.supportCours?.id,
                "refresh-trigger": _ctx.refreshKey
              }, null, 8, ["support-id", "refresh-trigger"])
            ])
          ], 512), [
            [_vShow, !_ctx.showAddQuestionForm]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddQuestionForm = false)),
              class: "btn btn-secondary mb-3"
            }, [
              _hoisted_156,
              _createTextVNode(" Retour à la liste ")
            ]),
            _createVNode(_component_AddQuestionQCM, {
              "current-support-id": _ctx.supportCours?.id,
              onQuestionAdded: _ctx.refreshQuestions
            }, null, 8, ["current-support-id", "onQuestionAdded"])
          ], 512), [
            [_vShow, _ctx.showAddQuestionForm]
          ])
        ]),
        _createElementVNode("div", _hoisted_157, [
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("form", {
                  class: "search-box position-relative",
                  onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
                    class: "form-control shadow-none text-black rounded-0 border-0",
                    placeholder: "Rechercher un cours en ligne"
                  }, null, 544), [
                    [_vModelText, _ctx.searchTerm]
                  ]),
                  _hoisted_161
                ], 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("table", _hoisted_164, [
                  _hoisted_165,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursenlignes, (coursenligne, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: coursenligne.id || index
                      }, [
                        _createElementVNode("td", _hoisted_166, _toDisplayString(coursenligne.nom), 1),
                        _createElementVNode("td", _hoisted_167, _toDisplayString(coursenligne.prenom), 1),
                        _createElementVNode("td", _hoisted_168, _toDisplayString(coursenligne.sexe), 1),
                        _createElementVNode("td", _hoisted_169, _toDisplayString(coursenligne.email), 1),
                        _createElementVNode("td", _hoisted_170, _toDisplayString(coursenligne.telephone1), 1),
                        _createElementVNode("td", _hoisted_171, _toDisplayString(_ctx.format_Date(coursenligne.dateNaissance)), 1),
                        _hoisted_172
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_173, [
                _createVNode(_component_PaginationComponent, {
                  page: _ctx.page,
                  totalPages: _ctx.totalPages,
                  totalElements: _ctx.totalElements,
                  limit: _ctx.limit,
                  onPaginate: _ctx.handlePaginate
                }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
              ])
            ])
          ])
        ]),
        _hoisted_174
      ])
    ]),
    (_ctx.showPdfModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal fade show d-block pdf-modal-overlay",
          tabindex: "-1",
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_175, [
            _createElementVNode("div", _hoisted_176, [
              _createElementVNode("div", _hoisted_177, [
                _createElementVNode("h5", _hoisted_178, [
                  _hoisted_179,
                  _createTextVNode(_toDisplayString(_ctx.currentPdfTitle), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_180, [
                (_ctx.currentPdfBlob)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: 0,
                      src: _ctx.currentPdfBlob,
                      class: "pdf-viewer-iframe",
                      title: "Visualiseur PDF"
                    }, null, 8, _hoisted_181))
                  : (_openBlock(), _createElementBlock("div", _hoisted_182, _hoisted_184))
              ]),
              _createElementVNode("div", _hoisted_185, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                }, "Fermer")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}